module.exports = __webpack_public_path__ + "img/alt5.37b62fca.jpg";